import { Box } from '@/common/components/base-app';
import { styled } from '@/stitches.config';

export const CampaignContainer = styled('li', {
  listStyleType: 'none',
});

export const RootListsContainer = styled('ul', {
  backgroundColor: '$white',
  borderRadius: '$8',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  padding: 0,
});

export const RootEmptyContainer = styled(Box, {
  backgroundColor: '$white',
  borderRadius: '$8',
  boxShadow: '$studyInsights$shadowBox',
  color: '$darkGray600',
  fontSize: '$lg',
  fontWeight: '$bold',
  padding: '$24 $6',
});
